import { FILTERABLE_FIELDS, isEmptyFilterValue, useFiltering } from '../../state/filtering.state';

import Carousel from '@ingka/carousel';
import { FilterPill } from './FilterPill';
import { Query } from '../../../../shared/types/query.types';
import get from 'lodash/get';
import keys from 'lodash/keys';
import styled from '@emotion/styled';
import { tokens } from '../../../../shared/styles/core/tokens';
import { useTableDataState } from '../../state/table-data.state';

export const FilterPillBar = () => {
   const query = useTableDataState((state) => state.query);

   const { isFiltered } = useFiltering();

   return isFiltered ? (
      <StyledCarousel hasNoScrollbar={true} hasNoControls={true}>
         {keys(FILTERABLE_FIELDS)
            .filter((field) => !isEmptyFilterValue(query[field as keyof Query]))
            .map((field) => (
               <FilterPill key={field} columnId={field} header={get(FILTERABLE_FIELDS, field)} value={query[field as keyof Query]} />
            ))}
      </StyledCarousel>
   ) : null;
};

const StyledCarousel = styled(Carousel)`
   padding-top: ${tokens.space.md};
   padding-left: 0;
   padding-right: 0;
   overflow-x: auto;

   .carousel__content {
      padding-bottom: ${tokens.space.sm};
   }

   .carousel__body {
      width: 95%;
   }
`;
